import Exception from "@/library/Exception";
import { Trade } from "@/library/Types";
import store from "@/store";

const trades = (): Array<Record<string, any>> => store.state.trade.trades;

const options = (): Record<string, any> => store.getters["trade/options"];

const selectedTrades = (): Trade[] => store.getters["trade/selectedTrades"];

const selectedIndex = (): number => store.state.trade.selectedIndex;

const type = (): string => store.state.trade.type;

//const quarterTrades = (): Trade[] => store.getters["trade/quarterTrades"];

const setSelectedIndex = (index: number): void => {
  store.commit("trade/setSelectedIndex", index);
};

const setType = (type: string): void => {
  store.commit("trade/setType", type);
};

const getTrades = async (): Promise<void> => {
  try {
    await store.dispatch("trade/getTrades");
  } catch (error) {
    await Exception.handle(error);
  }
};

export default {
  trades,
  options,
  selectedIndex,
  type,
  getTrades,
  setSelectedIndex,
  setType,
  //quarterTrades,
  selectedTrades,
};
